(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonial"] && !Shopify.designMode) return;
  try {
    
  class ReviewSlider {
    constructor(root) {
      this.root = root;
      this.slider = root.querySelector('[id^="Slider-"]');
      this.slides = Array.from(root.querySelectorAll('[id^="Slide-"]'));
      this.dotButtons = Array.from(root.querySelectorAll('.testimonial-band__dot-button'));
      this.prevButton = root.querySelector('button[name="previous"]');
      this.nextButton = root.querySelector('button[name="next"]');

      if (!this.slider || this.slides.length < 2) return;

      this.autoplayEnabled = root.dataset.autoplay === 'true';
      this.speed = (parseFloat(root.dataset.autoplaySpeed) || 6) * 1000;
      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.root.enableSliderLooping = true;
      this.currentIdx = 0;

      root.addEventListener('mouseenter', () => this.pause());
      root.addEventListener('mouseleave', () => this.resume());
      root.addEventListener('focusin', () => this.pause());
      root.addEventListener('focusout', () => this.resume());

      root.querySelectorAll('.slider-button').forEach((button) => {
        button.addEventListener('click', this.onArrowClick.bind(this), true);
      });

      this.dotButtons.forEach((dot, index) => {
        dot.addEventListener('click', () => {
          this.pause();
          this.goToSlide(index);
          this.resume();
        });
      });

      this.reducedMotion.addEventListener('change', () => (this.reducedMotion.matches ? this.stop() : this.resume()));

      let scrollTimeout;
      this.slider.addEventListener(
        'scroll',
        () => {
          clearTimeout(scrollTimeout);
          scrollTimeout = setTimeout(() => this.updateActiveDot(), 100);
        },
        { passive: true }
      );

      this.updateActiveDot();
      this.unlockArrows();
      this.resume();
    }

    stepSize() {
      return this.slides[1].offsetLeft - this.slides[0].offsetLeft;
    }

    /**
     * Navigates by index rather than re-deriving "current slide" from
     * scrollLeft: while a smooth-scroll from a previous click/tick is still
     * animating, scrollLeft reflects a mid-animation position, not the
     * destination. Clicking again before that finishes previously made
     * currentIndex() round to a stale/wrong slide, occasionally stepping
     * backward or re-landing on the same slide near the ends — reading as
     * the carousel "getting stuck". Tracking the intended index ourselves
     * keeps every click/tick a full, correct step regardless of timing.
     */
    goToSlide(index) {
      const total = this.slides.length;
      this.currentIdx = ((index % total) + total) % total;
      this.slider.scrollTo({ left: this.stepSize() * this.currentIdx, behavior: 'smooth' });
      this.setActiveDot(this.currentIdx);
    }

    currentIndex() {
      const maxScroll = this.slider.scrollWidth - this.slider.clientWidth;
      const atEnd = this.slider.scrollLeft >= maxScroll - 1;
      return atEnd ? this.slides.length - 1 : Math.round(this.slider.scrollLeft / this.stepSize());
    }

    unlockArrows() {
      [this.prevButton, this.nextButton].forEach((button) => {
        if (!button) return;
        button.removeAttribute('disabled');
      });
    }

    onArrowClick(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      const direction = event.currentTarget.name === 'next' ? 1 : -1;

      this.pause();
      this.goToSlide(this.currentIdx + direction);
      this.unlockArrows();
      this.resume();
    }

    setActiveDot(index) {
      if (!this.dotButtons.length) return;
      this.dotButtons.forEach((dot, i) => {
        const active = i === index;
        dot.classList.toggle('testimonial-band__dot-button--active', active);
        dot.setAttribute('aria-selected', active ? 'true' : 'false');
      });
      this.unlockArrows();
    }

    /**
     * Only for the manual-swipe/drag path (the scroll listener below): after
     * the user free-scrolls the track by hand, re-sync currentIdx and the
     * dots to wherever they actually landed, since that position can't be
     * predicted in advance the way a button click or autoplay tick can.
     */
    updateActiveDot() {
      this.currentIdx = this.currentIndex();
      this.setActiveDot(this.currentIdx);
    }

    resume() {
      if (this.reducedMotion.matches || !this.autoplayEnabled) return;
      this.stop();
      this.timer = setInterval(this.advance.bind(this), this.speed);
    }

    pause() {
      clearInterval(this.timer);
    }

    stop() {
      clearInterval(this.timer);
    }

    advance() {
      this.goToSlide(this.currentIdx + 1);
    }
  }

  document.querySelectorAll('.testimonial-band__slider').forEach((root) => new ReviewSlider(root));

  } catch(e) { console.error(e); }
})();
})();
